/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';

import {
  Card, CardBody, CardHeader,
} from 'reactstrap';

import { get } from '../../helpers/api_helper';

function Statistics(props) {
  const { t, item } = props;

  const [chartSeries, setChartSeries] = React.useState([]);

  const [chartOptions, setChartOptions] = React.useState({
    chart: {
      type: 'line',
      zoom: { enabled: false },
    },
    xaxis: {
      type: 'datetime',
    },
    yaxis: {
      title: { text: 'Usage' },
    },
    stroke: {
      curve: 'smooth',
      width: 3, // Line thickness (default is 2)
      colors: ['#34c38f'], // Line color (array for multiple series)
      dashArray: [0, 0], // Use [5, 5] for dashed lines
    },
    markers: {
      size: 3,
      colors: ['#34c38f'], // Custom color for markers
      strokeColors: '#FFFFFF', // Border color of the marker
      strokeWidth: 0, // Border thickness
      shape: 'circle', // Other options: "square"
      hover: {
        size: 8, // Marker size when hovered
      },
    },
    tooltip: {
      x: { format: 'dd MMM yyyy' },
      theme: 'dark', // Options: "dark", "light"
      style: {
        fontSize: '14px',
        fontFamily: 'Arial, sans-serif',
        color: '#FFFFFF', // Text color
      },
      fillSeriesColor: false, // Prevents tooltip text from using series color
      marker: {
        show: true,
      },
      background: {
        color: '#222222', // Custom background color
        borderRadius: '0px',
        borderColor: '#34c38f', // Custom border color
      },
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      const response = await get(`/api/items/reports/${item.id}/thirty`);

      const formattedData = (Array.isArray(response) ? response : [])
        .filter((entry) => entry && entry.week_start) // drop null/undefined
        .map((entry) => ({
          x: new Date(`${entry.week_start}T00:00:00Z`).getTime(), // timestamp (number)
          y: Number(entry.uses) || 0,
        }))
        .sort((a, b) => a.x - b.x);

      setChartOptions((prev) => ({
        ...prev,
        xaxis: {
          type: 'datetime',
          // IMPORTANT: no categories here
        },
      }));

      setChartSeries([{ name: 'Uses', data: formattedData }]);
    };

    fetchData();
  }, [item.id]);

  const jsx = (
    <div>
      {chartSeries.length > 0 && (
        <Card>
          <CardBody className="p-0">
            <Chart options={chartOptions} series={chartSeries} type="line" height={145} />
          </CardBody>
        </Card>
      )}
    </div>
  );

  return jsx;
}

Statistics.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  item: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(Statistics));
